import Component, { getInitialProps } from "../treasures/[id]"

export default function Treasure(props) {
	return <Component {...props} />
}

Treasure.getInitialProps = getInitialProps
